/* AutoAssignPreviewComponent.js */

"use strict";
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./AutoAssignPreviewRenderer");

class AutoAssignPreviewComponent extends EventEmitter {
    constructor(autoAssignResults, logger) {
        super();
        this._logger = logger;
        this._autoAssignResults = autoAssignResults;
        this._renderer = new Renderer(this);
        this._registerListeners();
        this._renderer.render();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {}

    _unregisterListeners() {}

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    get renderer() {
        return this.getRenderer();
    }

    get logger() {
        return this._logger;
    }

    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        this._unregisterListeners();
        return this._renderer.shutdown().then(
            () => {
                this._logger = undefined;
                this._renderer = undefined;
            },
            (err) => {
                this._logger.warn({ error: err }, "AutoAssignPreviewComponent.shutdown() error.");
            }
        );
    }

    cancelAction() {
        let err = new Error("user rejected");
        err.userRejected = true;
        return this.reject(err);
    }

    reject(err) {
        this._context.reject(err);
    }

    resolve(action) {
        this._context.resolve(action);
    }

    // prettier-ignore
    set "$teve.ui.context"(context) { //jshint ignore:line
        this._context = context;
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}
module.exports = AutoAssignPreviewComponent;
